module.exports = __webpack_public_path__ + "media/images/city/078-thatbyinnyu-temple-ea7c734648b1360828b01b8e95351cfb.svg";